var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1940,
    height: 381,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B82F6",
    stopOpacity: 0.64,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B82F6",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-28.8%",
    y: "-29%",
    width: "157.7%",
    height: "158%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 .15C116.406.15 0 115.87 0 258.616c0 142.748 116.406 258.467 260 258.467s260-115.72 260-258.467C519.834 115.937 403.525.315 260 .149Z",
    filter: "url(#b)",
    transform: "translate(1308 119)",
    fill: "url(#a)",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIllustration);
export default __webpack_public_path__ + "static/media/footer-illustration.2810da89b1f8fc063ed6520f8c4de7bf.svg";
export { ForwardRef as ReactComponent };